export default "__VITE_ASSET__72439900__"